/**
 * File navigation.js.
 */
(function () {
    const stickyHeader = document.body.querySelector('.sticky-header');
    if (stickyHeader) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 100) {
                stickyHeader.classList.remove('hidden');
            } else {
                stickyHeader.classList.add('hidden');
            }
        }, false);
    }

    let menuTimeout = 0;
    document.querySelectorAll('.menu-btn').forEach(function (menu) {
        menu.addEventListener('click', function() {
            if (document.body.classList.contains('menu--open')) {
                document.body.classList.remove('menu--open');
                document.body.classList.add('menu--close');
                if (menuTimeout)  {
                    clearTimeout(menuTimeout);
                }
                menuTimeout = setTimeout(() => {
                    document.body.classList.remove('menu--close');
                }, 450);
            } else {
                document.body.classList.add('menu--open');
                document.body.classList.remove('menu--close');
            }
        });
    });
}());
